import UserLayout from "../../component/Layout";
import EmployeeSkillSet from "../../components/search/EmployeeSkillSet";

const EmployeeSkillSetSearch = () => {
  
  return (
    <UserLayout>
       <main className="p-6 w-full max-w-screen-lg mx-auto">
         <EmployeeSkillSet/>
      </main> 
    
    </UserLayout>
  );
};

export default EmployeeSkillSetSearch;
